"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderDetail = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _index = require("../../atoms/Status/index");

var _index2 = require("../../atoms/ProgressBar/index");

var _index3 = require("../../atoms/Loading/index");

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/es");

var _styles = require("./styles");

var _Button = _interopRequireDefault(require("../../atoms/Button"));

var _Table = _interopRequireDefault(require("./utils/Table"));

var _DownloadIcon = _interopRequireDefault(require("../../../assets/images/Icons/DownloadIcon.svg"));

var _Spinner = _interopRequireDefault(require("../../../assets/images/Icons/Spinner.gif"));

var _jsxRuntime = require("react/jsx-runtime");

_moment.default.locale("es");

var OrderDetail = function OrderDetail(props) {
  var order = props.order;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(order.payment !== "pagado"),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showPaymentButton = _useState4[0],
      setShowPaymentButton = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      orderData = _useState6[0],
      setOrderData = _useState6[1];

  var _useState7 = (0, _react.useState)({
    approved: "-",
    rejected: "-",
    in_progress: "-",
    totalArticles: "-",
    percentage: "0.0",
    datasheet: "-",
    description: "-",
    images: "-"
  }),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      dataGeneral = _useState8[0],
      setDataGeneral = _useState8[1];

  var updBilling = function updBilling(articleId, newBillingStatus) {
    props.updateBilling && props.updateBilling({
      body: {
        orderId: order.id_order,
        articleId: articleId,
        newBillingStatus: newBillingStatus
      }
    });
    var items = document.querySelectorAll("[id^=\"Fact.\"]");
    var generalBilling = true;
    items.forEach(function (item) {
      if (!item.checked) {
        generalBilling = false;
        return;
      }
    });
    props.updateGeneralBilling(order.id_order, generalBilling);
  };

  (0, _react.useEffect)(function () {
    var ac = new AbortController();
    setIsLoading(true);
    props.getOrderDetail && props.getOrderDetail({
      query: {
        orderId: order.id_order
      }
    }).then(function (res) {
      var data = res.data,
          countArticles = res.countArticles,
          totalArticles = res.totalArticles;
      var obj = {};
      var orderKeys = ["UPC", "Nombre", "Cadena", "Servicios", "Estatus", "Fact.", "extends"];
      Object.keys(data).forEach(function (key) {
        obj[key] = {};
        orderKeys.forEach(function (header) {
          obj[key][header] = data[key][header];
        });
        obj[key]["Fact."].onChange = updBilling;
      });
      setOrderData(obj);
      setDataGeneral((0, _objectSpread2.default)((0, _objectSpread2.default)({}, countArticles), {}, {
        totalArticles: totalArticles
      }));
      setIsLoading(false);
    });
    return function () {
      return ac.abort();
    }; // Abort both fetches on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order.id_order]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MainContainer, {
    id: props.id,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Header, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SpaceBetween, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
          className: "headerTitle",
          children: ["Orden de trabajo ", order.id_order]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "buttons",
          children: [showPaymentButton && !props.isProvider && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            type: "primary",
            onClick: function onClick() {
              props.updatePaymentStatus(order.id_order, "pagado");
              setShowPaymentButton(false);
            },
            children: "Pagar"
          }), props.isDownloading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Spinner.default,
              alt: "Spinner",
              width: 30,
              height: 30
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
            onClick: function onClick() {
              props.download();
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _DownloadIcon.default,
              alt: "Download detail order"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            type: "image",
            onClick: function onClick() {
              props.setShowOrderDetail(false);
            },
            children: "\u2715"
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Details, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Detail, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "title",
            children: "Entrega estimada"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "date",
            children: order.deliver_date ? (0, _moment.default)(order.deliver_date).format("dddd DD [de] MMMM YYYY") : "Sin fecha asignada"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Detail, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "title",
            children: "Tipo de entrega"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: order.type
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Detail, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "title",
            children: "Estatus de la orden"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SpaceBetween, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Status, {
              statusType: order.status
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.ProgressBar, {
              percent: dataGeneral.percentage,
              progressBarType: order.status
            })]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "title",
            children: "APROBADOS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: [dataGeneral.approved, " / ", dataGeneral.totalArticles]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "title",
            children: "RECHAZADOS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: [dataGeneral.rejected, " / ", dataGeneral.totalArticles]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "title",
            children: "EN PROCESO"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: [dataGeneral.in_progress, " / ", dataGeneral.totalArticles]
          })]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "body",
      children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.Loading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.default, {
        headers: [{
          width: 210,
          name: "UPC"
        }, {
          width: 210,
          name: "Nombre"
        }, {
          width: 100,
          name: "Cadena",
          type: "groupImages"
        }, {
          width: 130,
          name: "Servicios",
          type: "services"
        }, {
          width: 70,
          name: "Estatus",
          type: "status"
        }, {
          width: 65,
          name: "Fact.",
          type: "checkout"
        }],
        data: orderData,
        isProvider: props.isProvider
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "footer",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "headerTitle",
        children: "Totales"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "title",
          children: "PRODUCTOS"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: dataGeneral.totalArticles
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "title",
          children: "FICHAS T\xC9CNICAS"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: dataGeneral.datasheet
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "title",
          children: "DESCRIPCIONES"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: dataGeneral.description
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Card, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "title",
          children: "IM\xC1GENES"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: dataGeneral.images
        })]
      })]
    })]
  });
};

exports.OrderDetail = OrderDetail;